export default {
  setStakeholders: (state, data) => {
    state.stakeholders.splice(0);

    // eslint-disable-next-line array-callback-return
    data.map((x) => {
      state.stakeholders.push({
        id: x.id,
        email: x.email,
        initials: generateInitials(x.name),
        name: x.name,
        phone: x.phone,
        institution: x.institution,
        group: x.group,
        position: x.position,
        city: x.city,
        region: x.region,
      });
    });
  },
  setTop: (state, data) => {
    state.top.splice(0);

    // eslint-disable-next-line array-callback-return
    data.slice(0, 15).map((x) => {
      state.top.push({
        id: x.id,
        email: x.email,
        initials: generateInitials(x.name),
        name: x.name,
      });
    });
  },
};

function generateInitials(name) {
  return name
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word[0].toUpperCase())
    .slice(0, 2)
    .join("");
}
